<script setup lang="ts">
import { defineAsyncComponent, onMounted } from 'vue';
import { APP_LOCALE } from '@/i18n/constants';
import { isDefined } from '@/utils';
import type { Locale } from '@/i18n/models';
import { RouterView } from 'vue-router';
import { useI18nStore } from '@/stores/i18n';

const isProduction = process.env.NODE_ENV === 'production';
const DeveloperPanel = defineAsyncComponent(() => import('@/components/DeveloperPanel/DeveloperPanel.vue'));

onMounted(() => {
  const locale = sessionStorage.getItem(APP_LOCALE) as Locale | null;
  if (isDefined(locale)) useI18nStore().set(locale);
});
</script>

<template>
  <main id="app" class="view-container main" role="main">
    <h1 class="visually-hidden">{{ $t('title:long') }}</h1>
    <div class="container-fluid em-page-grid px-0">
      <div class="px-0 d-flex flex-column-reverse flex-md-column">
        <RouterView />
        <DeveloperPanel v-if="!isProduction" />
      </div>
    </div>
  </main>
  <div class="iframe-helper-height-fix" />
</template>

<style lang="scss" scoped>
@use '@aab/sc-styles-utilities/dist/scss/styles' as utilities;
@use '~@aab/sc-styles-grid/dist/scss/styles.scss' as styles;
@import '@aab/sc-styles-fonts/sc-styles-font-roboto.css';
@import '@aab/sc-styles-fonts/sc-styles-font-roboto-condensed.css';
@import '~@/assets/_iframe-helper';

@include styles.container-fluid;
@include styles.em-page-grid;
@include utilities.flex-column-reverse;
@include utilities.flex-md-column;

.main {
  flex: 1 0 auto;
}
</style>
